import { useMutation, useQueryClient } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { partnerWorkerService } from 'partner/shared/services';

type DeletePartnerWorkerClaParams = {
  partnerWorkerId: string;
  collectiveLabourAgreementId: string;
};

export const useDeletePartnerWorkerCla = () => {
  const queryClient = useQueryClient();

  const mutationFn = async ({
    partnerWorkerId,
    collectiveLabourAgreementId,
  }: DeletePartnerWorkerClaParams) => {
    await partnerWorkerService.deletePartnerWorkerCla(partnerWorkerId, collectiveLabourAgreementId);
  };

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.workers());
    },
  });
};
